import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Field } from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';
import { Button, Typography, Grid } from '@material-ui/core';
import FormFileField from '../../form/FormFileField';

const BoardPostFilesFormItem = ({ t, disabled }) => (
  <FieldArray name="files">
    {({ fields, meta: { error } }) => (
      <React.Fragment>
        {error && typeof error === 'string' ? <Typography color="error" variant="caption">{error}</Typography> : null}
        {fields.map((fieldName, index) => (
          <Grid key={index} container direction="row" spacing={1} alignItems="center" alignContent="center">
            <Grid item>
              <div>
                <Field
                  type="file"
                  name={`${fieldName}file`}
                  component={FormFileField}
                />
              </div>
            </Grid>
            <Grid item>
              <Button size="small" onClick={() => fields.remove(index)} disabled={disabled}>{t('surveyDetails.detailsTab.removeButton')}</Button>
            </Grid>
          </Grid>
        ))}
        <Button
          style={{marginTop: 16}}
          variant="outlined"
          size="small"
          onClick={() => fields.push({})}
          disabled={disabled}
        >
          {t('boardThreadDetails.form.addFileButton')}
        </Button>
      </React.Fragment>
    )}
  </FieldArray>
);

BoardPostFilesFormItem.propTypes = {
  t: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default translate()(BoardPostFilesFormItem);



// WEBPACK FOOTER //
// ./src/components/consultationSurveys/board/BoardPostFilesFormItem.js